import { ArrowUpDown, ArrowUp, ArrowDown, Calendar, Type, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useSortPreference, type SortField, type SortOrder } from '@/hooks/useSortPreference';

const SORT_OPTIONS: { field: SortField; label: string; icon: typeof Calendar }[] = [
  { field: 'created_at', label: 'Date Added', icon: Calendar },
  { field: 'title', label: 'Title', icon: Type },
  { field: 'reading_time', label: 'Reading Time', icon: Clock },
];

function SortIcon({ order }: { order: SortOrder }) {
  return order === 'asc' ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />;
}

export function SortDropdown() {
  const { sortPreference, setSortField } = useSortPreference();

  const currentLabel =
    SORT_OPTIONS.find((opt) => opt.field === sortPreference.field)?.label ?? 'Date Added';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="gap-2 text-muted-foreground hover:text-foreground"
        >
          <ArrowUpDown className="h-4 w-4" />
          <span className="hidden sm:inline">{currentLabel}</span>
          <SortIcon order={sortPreference.order} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SORT_OPTIONS.map((option) => {
          const Icon = option.icon;
          const isActive = sortPreference.field === option.field;
          return (
            <DropdownMenuItem
              key={option.field}
              onClick={() => setSortField(option.field)}
              className="gap-2"
            >
              <Icon className="h-4 w-4" />
              {option.label}
              {isActive && (
                <span className="ml-auto">
                  <SortIcon order={sortPreference.order} />
                </span>
              )}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
